export default __webpack_public_path__ + "static/media/Futura-Bold.7bfa5614.woff";